module.exports = __webpack_public_path__ + "static/media/undraw_Questions_re_1fy7.463792d1.png";